var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.77903 0.341529C3.90107 0.21949 4.09893 0.21949 4.22097 0.341529L5.8616 1.98215C5.98363 2.10419 5.98363 2.30206 5.8616 2.4241C5.73956 2.54613 5.54169 2.54613 5.41965 2.4241L4 1.00444L2.58035 2.4241C2.45831 2.54613 2.26044 2.54613 2.1384 2.4241C2.01637 2.30206 2.01637 2.10419 2.1384 1.98215L3.77903 0.341529Z",
    fill: "#0061FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 0.25C4.17259 0.25 4.3125 0.389911 4.3125 0.5625V4.9375C4.3125 5.11009 4.17259 5.25 4 5.25C3.82741 5.25 3.6875 5.11009 3.6875 4.9375V0.5625C3.6875 0.389911 3.82741 0.25 4 0.25Z",
    fill: "#0061FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5625 4.625C0.735089 4.625 0.875 4.76491 0.875 4.9375V7.125H7.125V4.9375C7.125 4.76491 7.26491 4.625 7.4375 4.625C7.61009 4.625 7.75 4.76491 7.75 4.9375V7.125C7.75 7.29076 7.68415 7.44973 7.56694 7.56694C7.44973 7.68415 7.29076 7.75 7.125 7.75H0.875C0.70924 7.75 0.550269 7.68415 0.433058 7.56694C0.315848 7.44973 0.25 7.29076 0.25 7.125V4.9375C0.25 4.76491 0.389911 4.625 0.5625 4.625Z",
    fill: "#0061FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.919bd37bebfbb9a6a9e0f5741f76152c.svg";
export { ForwardRef as ReactComponent };